import React, { useState } from 'react';
import StoryModalView from './storyModalView';
import communityService from '../services/communityService.js';

const BlogList = ({ blogs, onOpenModal, onUpdateStory, currentUser }) => {
    const [selectedStory, setSelectedStory] = useState(null);

  // Helper function to strip HTML tags and get plain text
  const getPlainTextPreview = (htmlContent, maxLength = 100) => {
    if (!htmlContent) return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    const plainText = tempDiv.textContent || tempDiv.innerText || '';
    return plainText.length > maxLength 
      ? plainText.substring(0, maxLength) + '...'
      : plainText;
  };

  return (
    <div className="space-y-12">
      <h2 className="text-2xl font-bold text-gray-900">Featured Stories</h2>
      
      <div className="grid gap-8 lg:grid-cols-3">
        {blogs.map(blog => (
          <div key={blog.id} className="bg-white rounded-lg shadow-md overflow-hidden">
            <img
              className="h-48 w-full object-cover"
              src={blog.imageUrl || 'https://api.dicebear.com/6.x/initials/svg?seed=Ajo&style=identicon'}
              alt={blog.title}
            />
            <div className="p-6">
              <div className="flex items-center text-sm text-gray-500 mb-2">
                <span>{blog.name}</span>
                <span className="mx-2">•</span>
                <span>{communityService.formatDate(blog.createdAt)}</span>
              </div>
              <p className="text-gray-600 mb-4">
                {getPlainTextPreview(blog.content, 100)}
              </p>
              <button
                onClick={() => setSelectedStory(blog)}
                className="text-indigo-600 hover:text-indigo-800 text-sm font-medium"
              >
                View More →
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Share Your Story</h3>
        <p className="text-gray-600 mb-4">Have an inspiring savings story? We'd love to feature it!</p>
        <button 
          onClick={onOpenModal}
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700"
        >
          Submit Your Story
        </button>
      </div>
            {/* Story Modal */}
      <StoryModalView
        show={!!selectedStory}
        onClose={() => setSelectedStory(null)}
        story={selectedStory}
        onSave={onUpdateStory}
        currentUser={currentUser}
      />
    </div>
  );
};

export default BlogList;